export { Price as default } from './Price';
